// Pragmatic single-RFC-5321-ish regex. Catches typos (missing @, missing TLD,
// stray whitespace) without trying to fully implement the spec — backend +
// AWS SES will reject anything pathological the regex lets through, and
// surfaces that via the slice's errors array.
const EMAIL_REGEX = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

/**
 * Returns true when `value` looks like a syntactically valid email address.
 * Trimming is the caller's responsibility — we don't mutate input.
 *
 * This util is intentionally local to the Email Sender feature. The marketplace
 * has no shared `validateEmail` helper today (the existing call sites all
 * re-declare their own regex); promoting one is out of scope for this work.
 */
export const validateSenderEmail = (value: string): boolean => {
    return EMAIL_REGEX.test(value);
};
